export const VISUALISATION_COMPONENTS_LIST = ['<Standard>', 'positionableProgressBar', 'genericProgressBar', 'waveProgressBar', 'waveHands', 'waveWin', 'fallingObjects', 'f2uReward', ];
